import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import guide from './guide.json';
import './help.css';

export default function Help() {
  const { user } = useAuth();
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('All topics');
  const articles = guide.filter(article => article.roles.includes(user?.role || 'Employee'));
  const visible = articles.filter(article =>
    (category === 'All topics' || article.category === category) &&
    `${article.title} ${article.intro} ${article.steps.join(' ')} ${article.tips.join(' ')}`.toLowerCase().includes(query.trim().toLowerCase()));
  const download = () => {
    const text = `# Cafe Ops mobile guide\n\nGuide for ${user?.role || 'Employee'}\n\n` + articles.map(article =>
      `## ${article.title}\n\n${article.intro}\n\n${article.steps.map((step, index) => `${index + 1}. ${step}`).join('\n')}\n\n${article.tips.map(tip => `- ${tip}`).join('\n')}`).join('\n\n');
    const url = URL.createObjectURL(new Blob([text], { type: 'text/markdown;charset=utf-8' }));
    const link = document.createElement('a'); link.href = url; link.download = 'cafe-ops-mobile-guide.md'; link.click();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  return <section className="help-page">
    <div className="help-intro"><p className="help-eyebrow">CAFE OPS · MOBILE GUIDE</p><h2>How can we help?</h2>
      <p>Short instructions for your shift, your profile and the tools available to your role.</p>
      <span className="help-role">Guide for {user?.role || 'Employee'}</span>
    </div>
    <div className="help-search cs-sticky"><label htmlFor="help-search">Search the guide</label>
      <input id="help-search" type="search" placeholder="Try pay stub, cash, profile or offline" value={query} onChange={event => setQuery(event.target.value)} />
      <label htmlFor="help-category">Topic</label><select id="help-category" value={category} onChange={event => setCategory(event.target.value)}>
        {['All topics', ...Array.from(new Set(articles.map(article => article.category)))].map(item => <option key={item}>{item}</option>)}
      </select>
    </div>
    <p className="help-count" role="status">{visible.length} {visible.length === 1 ? 'topic' : 'topics'}{query ? ` matching “${query}”` : ''}</p>
    {visible.length === 0 && <div className="help-empty"><h3>No matching topics</h3><p>Try a shorter word or choose All topics.</p><button className="salary-btn secondary" onClick={() => { setQuery(''); setCategory('All topics'); }}>Clear search</button></div>}
    {visible.map(article => <details className="help-article" key={`${article.id}:${query ? 'search' : 'browse'}`} open={query.trim() ? true : undefined}>
      <summary><span className="help-category">{article.category}</span><span>{article.title}</span></summary>
      <div className="help-article-body"><p>{article.intro}</p><ol>{article.steps.map(step => <li key={step}>{step}</li>)}</ol>
        <aside><h3>Good to know</h3><ul>{article.tips.map(tip => <li key={tip}>{tip}</li>)}</ul></aside>
        <Link className="salary-btn secondary" to={article.path}>{article.action}</Link>
      </div>
    </details>)}
    <div className="help-download"><h3>Keep a copy</h3><p>Download a text guide for your role. It contains instructions only, without your account or payroll details.</p><button className="salary-btn secondary" onClick={download}>Download mobile guide</button></div>
    <p className="help-count">Updated September 2026. For account or operational help, contact an Owner or Admin.</p>
  </section>;
}
